:host {
  display: contents;
  width: 100%;
  box-sizing: border-box;
  --_omk-list-container-color: var(--omk-list-container-color, var(--omk-colour-container-primary-resting));
  --_omk-list-container-border-radius: var(--omk-list-container-border-radius, var(--omk-dimension-border-radius-medium));

  --_omk-list-container-padding: var(--omk-list-container-padding, 0 var(--omk-dimension-spacing-small));

  --_omk-list-outline-size: var(--omk-list-outline-size, var(--omk-dimension-border-width-normal));
  --_omk-list-outline-colour: var(--omk-list-outline-colour, var(--omk-colour-border-primary-resting));

  --_omk-list-validation-container-padding: var(--omk-list-validation-container-padding, var(--omk-dimension-spacing-xxsmall) var(--omk-dimension-spacing-small) var(--omk-dimension-spacing-xxxsmall) var(--omk-dimension-spacing-small));
  --_omk-list-validation-container-gap: var(--omk-list-validation-container-gap, var(--omk-dimension-spacing-xxxsmall));

  --_omk-list-validation-text-color: var(--omk-list-validation-text-color, var(--omk-colour-text-danger-resting));
  --_omk-list-validation-text-font-family: var(--omk-list-validation-text-font-family, var(--omk-font-body-xsmall-high-emphasis-font-family));
  --_omk-list-validation-text-font-size: var(--omk-list-validation-text-font-size, var(--omk-font-body-xsmall-high-emphasis-font-size));
  --_omk-list-validation-text-font-weight: var(--omk-list-validation-text-font-weight, var(--omk-font-body-xsmall-high-emphasis-font-weight));
  --_omk-list-validation-text-line-height: var(--omk-list-validation-text-line-height, var(--omk-font-body-xsmall-high-emphasis-line-height));

  --_omk-list-validation-icon-color: var(--omk-list-validation-icon-color, var(--omk-colour-icon-danger-resting));
  --_omk-list-validation-icon-size: var(--omk-list-validation-icon-size, 20px);

  --md-list-container-color: var(--_omk-list-container-color);
}

:host(.full-width), .full-width {
  md-list {
    border-radius: 0;
    border: none;
  }

  .container {
    padding: 0;
  }
}

md-list {
  border-radius: var(--_omk-list-container-border-radius);
  padding: 0;

  &.outlined {
    border: var(--_omk-list-outline-size) solid var(--_omk-list-outline-colour);
  }
}

.container {
  display: inline-block;
  padding: var(--_omk-list-container-padding);
  width: 100%;
}

.validation-area {
  display: flex;
  padding: var(--_omk-list-validation-container-padding);
  align-items: center;
  gap: var(--_omk-list-validation-container-gap);
  align-self: stretch;

  color: var(--_omk-list-validation-text-color);
  font-family: var(--_omk-list-validation-text-font-family);
  font-size: var(--_omk-list-validation-text-font-size);
  font-weight: var(--_omk-list-validation-text-font-weight);
  line-height: var(--_omk-list-validation-text-line-height);

  omk-icon {
    color: var(--_omk-list-validation-icon-color);
    --omk-icon-size: var(--_omk-list-validation-icon-size);
    font-size: var(--_omk-list-validation-icon-size);
  }
}
